export const FETCH_STUDENT_ANALYTICS_REQUEST = 'FETCH_STUDENT_ANALYTICS_REQUEST';
export const FETCH_STUDENT_ANALYTICS_SUCCESS = 'FETCH_STUDENT_ANALYTICS_SUCCESS';
export const FETCH_STUDENT_ANALYTICS_FAILURE = 'FETCH_STUDENT_ANALYTICS_FAILURE';
export const FETCH_CONTENT_PERFORMANCE_REQUEST = 'FETCH_CONTENT_PERFORMANCE_REQUEST';
export const FETCH_CONTENT_PERFORMANCE_SUCCESS = 'FETCH_CONTENT_PERFORMANCE_SUCCESS';
export const FETCH_CONTENT_PERFORMANCE_FAILURE = 'FETCH_CONTENT_PERFORMANCE_FAILURE';
export const EXPORT_ANALYTICS_REPORT_REQUEST = 'EXPORT_ANALYTICS_REPORT_REQUEST';
export const EXPORT_ANALYTICS_REPORT_SUCCESS = 'EXPORT_ANALYTICS_REPORT_SUCCESS';
export const EXPORT_ANALYTICS_REPORT_FAILURE = 'EXPORT_ANALYTICS_REPORT_FAILURE';